'use client';

import { CSSProperties, useEffect, useRef, useState } from 'react';
import { Content, GroupField } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';
import { FinanceAccessCard } from './FinanceAccessCard/FinanceAccessCard';

import styles from './financeAccessSlider.module.scss';

interface FinanceAccessSliderProps {
  items: GroupField<
    Simplify<Content.FinanceAccessSliceDefaultPrimaryCardsItem>
  >;
}

export const FinanceAccessSlider = ({ items }: FinanceAccessSliderProps) => {
  // const cardRef = useRef<HTMLDivElement | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const [slideWidth, setSlideWidth] = useState(0);

  useEffect(() => {
    if (wrapperRef.current) {
      const wrapperWidth = wrapperRef.current.scrollWidth;
      const containerWidth = wrapperRef.current.clientWidth;
      const calculatedSlideWidth = wrapperWidth - containerWidth;

      setSlideWidth(calculatedSlideWidth + 24);
    }
  }, [items, wrapperRef]);

  const wrapperStyle: CSSProperties & { [key: string]: string | number } = {
    '--slide-width': `${-slideWidth}px`,
  };

  return (
    <article ref={wrapperRef} className={styles.cards} style={wrapperStyle}>
      {items.map((card, index) => (
        <FinanceAccessCard card={card} key={index} />
      ))}
    </article>
  );
};
